import { ModaliteReunion } from './modaliteReunion';
import { Prestation } from './prestation';
import { TypeDocument } from './typeDocument';
import { TypeEntretien } from './typeEntretien';

export class PrestationFichier {
	id: number;
	typeDocument: TypeDocument;
	prestation: Prestation;
	file: File;
	gedId: string;
	date: string;
	filename: string;

	constructor(
		options: {
			id?: number;
			typeDocument?: TypeDocument;
			prestation?: Prestation;
			gedId?: string;
			date?: string;
			filename?: string;
		} = {}
	) {
		this.id = options.id || null;
		this.typeDocument = options.typeDocument || new TypeDocument();
		this.prestation = options.prestation || new Prestation();
		this.gedId = options.gedId || null;
		this.date = options.date || null;
		this.filename = options.filename || null;
	}
}
